import React from "react";
import { Link,useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const SideNavbar = ({ setHamberger }) => {
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.user);

  const closeMenu = () => setHamberger(false);

  //  SERVICE HANDLER FOR MOBILE
  const handleService = () => {
    closeMenu();
    if (!isAuthenticated) {
      navigate("/login-with-otp");
    } else {
      navigate("/my-complaints");
    }
  };

  return (
    <>
      {/*  BACKDROP */}
      <div
        onClick={closeMenu}
        className="fixed inset-0 bg-black/40 z-30"
      />

      {/*  SIDEBAR */}
      <div className="fixed top-0 left-0 h-full w-[260px] text-black bg-white z-40 shadow-xl p-5 space-y-4">

        <Link onClick={closeMenu} to="/" className="block font-semibold">
          Home
        </Link>

        <Link onClick={closeMenu} to="/about-us" className="block font-semibold">
          About Us
        </Link>

        <Link
          onClick={closeMenu}
          to="/small-appliances"
          className="block font-semibold"
        >
          Small Appliances
        </Link>

        <Link
          onClick={closeMenu}
          to="/luxury-appliances"
          className="block font-semibold"
        >
          Luxury Appliances
        </Link>

        <Link onClick={closeMenu} to="/contact-us" className="block font-semibold">
          Contact Us
        </Link>

        <button
          onClick={handleService}
          className="block text-left font-semibold w-full"
        >
          Service
        </button>

        <Link onClick={closeMenu} to="/blogs" className="block font-semibold">
          Blog
        </Link>
        <Link onClick={closeMenu} to="/awards" className="block font-semibold">
          Awards
        </Link>

        <Link onClick={closeMenu} to="/login" className="block font-semibold">
          Login
        </Link>
      </div>
    </>
  );
};

export default SideNavbar;
